module.exports = "/_next/static/images/03a893f210d141faddd41ef2d4eaf6f1-nu-card-md@3x.jpg.webp";